import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { config } from '@uhg-abyss/web/tools/config';
import { V2Footer } from '@uhg-abyss/web/ui/Footer';

const FooterText = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  fontSize: 14,
  color: '$gray9',
  flexWrap: 'wrap',
  rowGap: '12px',
});

const FooterLinks = styled('ul', {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '20px',
  margin: 0,
  padding: 0,
  listStyle: 'none',
});

const FooterNav = styled('nav', {
  marginLeft: 'auto',
});

export const Footer = () => {
  return (
    <V2Footer
      variant="alt"
      css={{
        'abyss-footer-container': { paddingTop: '0px' },
      }}
    >
      <V2Footer.SubFooter
        css={{
          'abyss-footer-sub-wrapper': {
            borderTopWidth: '0px',
          },
        }}
      >
        <FooterText>
          <span>UnitedHealthcare Services | All Rights Reserved</span>
          <FooterNav aria-label="Footer links">
            <FooterLinks>
              <V2Footer.Link
                hideIcon
                id="privacy-policy"
                href={config('UHC_PRIVACY_URL')}
                rel="noreferrer"
                target="_blank"
              >
                Privacy Policy
              </V2Footer.Link>
              <V2Footer.Link
                hideIcon
                id="terms-of-use"
                href={config('UHC_TERMS_OF_USE_URL')}
                rel="noreferrer"
                target="_blank"
              >
                Terms of Use
              </V2Footer.Link>
              <V2Footer.Link
                hideIcon
                id="accessibility"
                href={config('UHC_ACCESSIBILITY_URL')}
                rel="noreferrer"
                target="_blank"
              >
                Accessibility
              </V2Footer.Link>
              <V2Footer.Link
                hideIcon
                id="contact-us"
                href={config('UHC_CONTACT_US_URL')}
                rel="noreferrer"
                target="_blank"
              >
                Contact Us
              </V2Footer.Link>
            </FooterLinks>
          </FooterNav>
        </FooterText>
      </V2Footer.SubFooter>
    </V2Footer>
  );
};
